import ClassNames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { icons } from '../complexicons';

/**
 * Here lies any icon with transparency, animation, or more than one color.
 */
function ComplexIcon({ name, svgProps, classes }) {
  return !icons[name] ? null : (
    <div className={ClassNames('Icon--complex', classes)}>{icons[name](svgProps)}</div>
  );
}

ComplexIcon.defaultProps = {
  svgProps: {},
};

ComplexIcon.propTypes = {
  /**
   * Additional classes to apply to the `div` container
   */
  classes: PropTypes.string.isRequired,
  /**
   * Name of the icon to show
   */
  name: PropTypes.string.isRequired,
  /**
   * Props to be applied to the `svg` icon.
   */
  // eslint-disable-next-line react/forbid-prop-types
  svgProps: PropTypes.object,
};

export default ComplexIcon;
